import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setToken, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = logged-out
  const [error, setError] = useState(null);

  const fetchMe = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    }
  };

  useEffect(() => {
    fetchMe();
    // eslint-disable-next-line
  }, []);

  const login = async (email, password) => {
    setError(null);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.token) setToken(data.token);
      setUser(data.user);
      return data.user;
    } catch (e) {
      const msg = formatApiError(e);
      setError(msg);
      throw new Error(msg);
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, error, login, logout, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  admin_ops: "Admin / Operations",
  sales_ib: "Sales / IB",
  broker_viewer: "Broker Viewer",
  participant_viewer: "Participant Viewer",
};

export const can = (user, action) => {
  if (!user) return false;
  const role = user.role;
  const map = {
    manage: ["super_admin", "admin_ops"],
    sales: ["super_admin", "admin_ops", "sales_ib"],
    audit_view: ["super_admin", "admin_ops"],
    users: ["super_admin"],
    upload: ["super_admin", "admin_ops"],
    approve_payout: ["super_admin", "admin_ops"],
  };
  return (map[action] || []).includes(role);
};
